<template>
  <div v-if="loadEntity">
    <div class="row">
      <div class="col-md-12">

        <div class="form-group">
          <label for="account-name">Nome</label>
          <input v-model="partnerAccount.name" type="text" class="form-control" id="account-name" aria-describedby="emailHelp">
        </div>

        <div class="form-group">
          <label for="account-responsible-name">Nome do Responsável</label>
          <input v-model="partnerAccount.responsibleName" type="text" class="form-control" id="account-responsible-name">
        </div>

        <div class="form-group">
          <label for="account-domain">Domínio</label>
          <input v-model="partnerAccount.domain" type="text" class="form-control" id="account-domain">
        </div>

        <div class="form-group">
          <label for="company-phone">Telefone</label>
          <input v-model="partnerAccount.phone" type="text" class="form-control" id="company-phone" v-mask="'(##) #### #####'">
        </div>

        <div class="form-group">
          <label for="account-address">Endereço</label>
          <input v-model="partnerAccount.address" type="text" class="form-control" id="account-address">
        </div>

        <div class="form-group">
          <label>UF</label>
          <StatesSelect v-model="partnerAccount.uf" class="form-control"/>
        </div>

        <div class="form-group">
          <label>Cidade</label>
          <CitySelect v-model="partnerAccount.cityCode" :code-uf="partnerAccount.uf" class="form-control"/>
        </div>

        <div class="form-group">
          <label for="account-style">Estilo</label>
          <textarea
            @keydown.tab.prevent=""
            id="account-style"
            :value="toJson(partnerAccount.style)"
            ref="style"
            rows="10"
            class="form-control account-metadata mb-2"
            :key="textAreaKey"
          />
        </div>

        <div class="form-group">
          <label for="account-address">Logo</label>
          <Upload class="upload" is-multiple="false" accept="image/jpg, image/jpeg, image/png, image/gif" :method="setFile">
            <UploadCloudIcon size="2x" class="upload-icon"/>
            <p>Selecione ou arraste o seu arquivo de logo</p>
          </Upload>
        </div>

        <div class="form-group"
             v-if="partnerAccount.logoUrl"
        >
          <label>Logo atual</label>
          <div>
            <img style="height: 3rem;" :src="partnerAccount.logoUrl">
          </div>
        </div>

      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <button class="btn btn-primary btn-lg mr-2" @click="save">
          Salvar
        </button>
      </div>
    </div>
  </div>

  <div v-else>
    <strong>carregando</strong>
  </div>
</template>

<script>
import CitySelect from '@/components/shares/specialTag/CitySelect'
import StatesSelect from '@/components/shares/specialTag/StatesSelect.vue'
import ModelMapper from '@/mixins/ModelMapper'

import EntityProxy from '@/models/EntityProxy'
import CustomFormData from '@/models/CustomFormData'
import Upload from '@/components/shares/specialTag/Upload'
import { Converter } from '@/models/converter'

import { mask } from 'vue-the-mask'
import { mapMutations } from 'vuex'
import { UploadCloudIcon } from 'vue-feather-icons'

const toSnakeCase = string => {
  return new Converter({
    data: string,
    converterName: 'snakecase'
  }).perform()
}

export default {
  components: { CitySelect, StatesSelect, Upload, UploadCloudIcon },
  computed: {
    account() {
      return this.getModel || {}
    }
  },
  created() {
    if (this.id === 'new') {
      this.setNameBreadcrumb('[Nova conta]')
      this.loadEntity = true
      return
    }

    this.loadAccount()
  },
  data: () => ({
    partnerAccount: EntityProxy.build({}),
    nameModel: 'Account',
    loadEntity: false,
    textAreaKey: 0
  }),
  directives: { mask },
  methods: {
    ...mapMutations(['setNameBreadcrumb']),
    buildPath() {
      return 'admin/partner_accounts'
    },
    save() {
      const value = this.$refs.style.value

      try {
        this.partnerAccount.style = JSON.parse(value)
      } catch (e) {
        this.$notify.addError('Style mal formatado!')
        this.textAreaKey++
        return
      }

      const message = this.partnerAccount.id ?
        'Conta atualizado com Sucesso!' : 'Conta criada com Sucesso!'

      this.asyncTemplateSave(this.partnerAccount, {
        after: ({model}) => {
          this.$notify.add(message)
          this.partnerAccount = EntityProxy.clone(model)
        },
      })
    },
    loadAccount() {
      this.openGlobalLoad()
      this.axios.get(`admin/accounts/${this.id}?methods=logo_url`)
        .then(response => response.data)
        .then(data => this.partnerAccount = EntityProxy.clone(data))
        .then(() => this.setNameBreadcrumb(this.partnerAccount.name))
        .then(() => this.loadEntity = true)
        .catch(e => this.$notify.addError(e))
        .finally(() => this.closeGlobalLoad())
    },
    setFile(files) {
      this.partnerAccount.logo = files[0]
    },
    buildData() {
      let formData = new CustomFormData()
      this.partnerAccount.each((key, value) => {
        key = toSnakeCase(key)
        formData.append(key, value)
      })
      return formData
    },
    buildHeaders() {
      return { 'Content-Type': 'multipart/form-data' }
    },
    toJson(data) {
      return JSON.stringify(data, null, 2)
    }
  },
  mixins: [ModelMapper],
  name: 'NewPartnerAccount',
  props: {
    id: { required: true }
  }
}
</script>

<style scoped>
.upload {
  position: relative;
  z-index: 1;
  margin-bottom: 1rem;
}

.form-group {
  position: relative;
  z-index: auto;
}

.btn {
  position: relative;
  z-index: 10;
}
</style>
